import React, { useMemo, useState } from "react";
import { BsGripVertical } from "react-icons/bs";
import moment from "moment";
import Folder from "../../../assets/image14.svg";
import PDFI from "../../../assets/pdf.svg";
import GIFI from "../../../assets/gif.svg";
import JPGI from "../../../assets/jpg.svg";
import PNGI from "../../../assets/png.svg";
import TXTI from "../../../assets/txt.svg";
import CSVI from "../../../assets/csv.svg";
import DOCXI from "../../../assets/doscii.svg";
import XLSXI from "../../../assets/xlsx.svg";
import DOCI from "../../../assets/doc.svg";
import FileIcon from "../../../assets/file.svg";
import { PortalDropDown } from "../Enhansment/DropDown/DropdownMenu/PortalDropDown";
import {
  baseURLImage,
  formatDateIntoDMYToDisplay,
  formatFolderContentsLabel,
  getDocumentFolderCounts,
  sanitizeDocumentUrl,
  textTruncate,
} from "Utils/utils";
import { openDocumentPreviewInNewTab } from "Utils/attachmentPreview";
import { apiCall } from "store/services/service";
import {
  URL_GET_FILE,
  URL_SIL_ACCOMMODATION_DOCUMENT_VIEW_FILE,
  URL_WORKER_GET_FILE,
} from "store/services/URL";
import { RiGitRepositoryPrivateLine } from "react-icons/ri";
import { MdOutlinePublic } from "react-icons/md";
import { XIcon, InformationCircleIcon } from "@heroicons/react/outline";
import { BASE_URL } from "store/services/URL";
import { toast } from "react-toastify";
import {
  canAccessDocumentAction,
  canAccessFrontlineMyDocumentsFolderAction,
  canParticipantDocumentFolderDelete,
  isParticipantFolderDeleteDeniedError,
  PARTICIPANT_DOCUMENT_FOLDER_DELETE_DENIED,
  usePermissionsVersion,
  DOCUMENT_PERMISSION_ACTIONS,
  isFrontlineEmployeeUser,
  roleAccess,
} from "helpers/RolesPermission";
import { USER_ROLE, DOCUMENT_CONSTANTS } from "Constants/constant";
import { connect } from "react-redux";
import { getUser } from "store/selector/auth.selector";
import Loader from "../Loader/Loader";
import { lowerCase } from "lodash";
import ConfirmationModal from "../Modal/ConfirmationModal";

/** HTML5 drag payload for moving documents onto a folder (participant / worker UIs pass onMoveDrop). */
export const VERTEX_DOC_MOVE_TO_FOLDER_MIME = "application/x-vertex-doc-move-to-folder";

const REQUIRED_DOCUMENTS_FOLDER_NAME = "required documents";

const DOC_ACTION_BTN =
  "inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-500 shadow-sm transition-colors hover:bg-gray-50 hover:text-blue-600 hover:border-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/30";

const DOC_ACTION_BTN_ACTIVE =
  "inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-blue-200 bg-blue-50 text-blue-600 shadow-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/30";

const DOC_ACTION_TOOLBAR =
  "flex items-center justify-end gap-1 shrink-0 max-w-full";

const DOC_ACTION_ICON = "h-3.5 w-3.5";

const FolderView = (props) => {
  const {
    setUpdatePermission,
    onFilePermissionUpdate, // Callback to update file in parent state
    role,
    ext,
    permissionRename,
    type,
    badged,
    label,
    createdDate,
    onClick,
    onFileClick,
    item,
    removeFolder,
    removeFile,
    isEdit,
    isEditt,
    currentFolder,
    currentFile,
    currentLoginUser,
    isUserGracePeriodOver,
    viewMode = "grid", // "grid" or "list"
    metadataItemId, // ID of the item whose metadata should be shown
    onToggleMetadata, // Callback to toggle metadata
    onMoveToFolder,
    enableMoveToFolder = false,
    /** When set with enableMoveToFolder, shows a drag handle and (for folder cards) accepts drops. */
    onMoveDrop,
    /** When "worker", non–admin/manager roles (e.g. sp_cos) use HRM view-file; admin/manager keep SP URL. */
    fileViewContext,
    /** Participant / HRM worker / Home Management documents only (V360-5206). */
    showFolderItemCounts = false,
    /** Required Documents folder and similar — no Remove/Rename in ⋮ menu. */
    isLockedFolder = false,

    //not use
    documents,
    response,
  } = props;

  const [isLoadingViewFile, setIsLoadingViewFile] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMoveDropOver, setIsMoveDropOver] = useState(false);

  const permissionsVersion = usePermissionsVersion();

  const showMoveDropTarget = type === "folder" && typeof onMoveDrop === "function";

  const isBlackPortalParticipantDocuments =
    role === "participant" && roleAccess([USER_ROLE.Sp_Standard_User]);
  const isFrontlinePortalDocs =
    isBlackPortalParticipantDocuments ||
    (role === "hrm" && isFrontlineEmployeeUser());
  const canFolderMenuAction = (action) =>
    role === "hrm" && isFrontlineEmployeeUser()
      ? canAccessFrontlineMyDocumentsFolderAction(action)
      : canAccessDocumentAction(role, action);

  const canRemoveParticipantFolder = useMemo(
    () => role === "participant" && canParticipantDocumentFolderDelete(),
    [role, permissionsVersion]
  );

  const frontlineFolderHasMenuActions =
    !isLockedFolder &&
    (canFolderMenuAction(DOCUMENT_PERMISSION_ACTIONS.FOLDER_UPDATE) ||
      canFolderMenuAction(DOCUMENT_PERMISSION_ACTIONS.FOLDER_DELETE) ||
      enableMoveToFolder);
  const primaryPortalParticipantFolderHasMenu =
    role === "participant" &&
    !isBlackPortalParticipantDocuments &&
    !isLockedFolder &&
    (canRemoveParticipantFolder ||
      canFolderMenuAction(DOCUMENT_PERMISSION_ACTIONS.FOLDER_UPDATE) ||
      enableMoveToFolder);
  /** BLK participant docs: folder cards are info-only. My Documents: ⋮ when permitted. */
  const hideFolderActionsMenu =
    type === "folder" &&
    (isBlackPortalParticipantDocuments ||
      (isFrontlinePortalDocs &&
        (isLockedFolder || !frontlineFolderHasMenuActions)) ||
      (role === "participant" &&
        !isBlackPortalParticipantDocuments &&
        !isFrontlinePortalDocs &&
        !primaryPortalParticipantFolderHasMenu));
  const docCardContentPad = isFrontlinePortalDocs ? "pl-3" : "pl-9";

  const handleMoveDragStart = (e) => {
    e.stopPropagation();
    e.dataTransfer.effectAllowed = "move";
    try {
      e.dataTransfer.setData(
        VERTEX_DOC_MOVE_TO_FOLDER_MIME,
        JSON.stringify({ draggedType: type, draggedItem: item })
      );
    } catch {
      // setData can throw for very large payloads in some browsers
    }
  };

  const handleFolderDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMoveDropOver(false);
    if (!showMoveDropTarget) return;
    let parsed;
    try {
      const raw = e.dataTransfer.getData(VERTEX_DOC_MOVE_TO_FOLDER_MIME);
      if (!raw) return;
      parsed = JSON.parse(raw);
    } catch {
      return;
    }
    const { draggedType, draggedItem } = parsed || {};
    if (!draggedItem || !draggedType) return;
    if (draggedType === "folder" && draggedItem.id != null && draggedItem.id === item.id) return;
    onMoveDrop({ draggedItem, draggedType, targetFolder: item });
  };

  const handleFolderDragEnter = (e) => {
    if (!showMoveDropTarget) return;
    e.preventDefault();
    setIsMoveDropOver(true);
  };

  const handleFolderDragLeave = (e) => {
    if (!showMoveDropTarget) return;
    const related = e.relatedTarget;
    if (!related || !e.currentTarget.contains(related)) {
      setIsMoveDropOver(false);
    }
  };

  const handleFolderDragOver = (e) => {
    if (!showMoveDropTarget) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const renderMoveDragHandle = () => {
    if (!enableMoveToFolder || typeof onMoveDrop !== "function") return null;
    return (
      <button
        type="button"
        data-doc-move-drag
        title="Drag onto a folder to move"
        draggable
        onDragStart={handleMoveDragStart}
        onClick={(e) => e.stopPropagation()}
        className={`${DOC_ACTION_BTN} cursor-grab active:cursor-grabbing`}
      >
        <BsGripVertical className={DOC_ACTION_ICON} aria-hidden />
      </button>
    );
  };

  const showMetadata = metadataItemId === (item.uuid || `item-${item.id}`);
  const metadataActionLabel =
    type === "file" ? "View file information" : "View folder information";

  const renderMetadataButton = (buttonClassName = DOC_ACTION_BTN) => {
    if (!onToggleMetadata) return null;

    return (
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onToggleMetadata(item.uuid || `item-${item.id}`, showMetadata);
        }}
        className={showMetadata ? DOC_ACTION_BTN_ACTIVE : buttonClassName}
        title={metadataActionLabel}
        aria-label={metadataActionLabel}
      >
        <InformationCircleIcon className={DOC_ACTION_ICON} aria-hidden />
      </button>
    );
  };

  const renderMenuButton = () => {
    if (hideFolderActionsMenu) {
      return null;
    }
    if (isLoadingViewFile === item.uuid) {
      return (
        <span className="inline-flex h-7 w-7 items-center justify-center">
          <Loader isSmallView={true} cssClass="text-gray-600 mr-0" />
        </span>
      );
    }

    return (
      <PortalDropDown
        isUserGracePeriodOver={isUserGracePeriodOver}
        role={role}
        permissionRename={permissionRename}
        type={type}
        clickHandler={(e) => handleClickHandler(e)}
        onMenuStateChange={handleMenuStateChange}
        enableMoveToFolder={enableMoveToFolder}
        isLockedFolder={type === "folder" && isLockedFolder}
        triggerClassName={DOC_ACTION_BTN}
      />
    );
  };

  const renderActionToolbar = (toolbarClassName = "") => (
    <div
      className={`${DOC_ACTION_TOOLBAR} ${toolbarClassName}`}
      onClick={(e) => e.stopPropagation()}
    >
      {renderMetadataButton()}
      {renderMoveDragHandle()}
      {renderMenuButton()}
    </div>
  );

  const isRequiredDocumentsFolder =
    type === "folder" &&
    (item?.name || label || "").trim().toLowerCase() === REQUIRED_DOCUMENTS_FOLDER_NAME;

  const showDocumentFolderCounts =
    showFolderItemCounts && type === "folder" && !isRequiredDocumentsFolder;

  const folderContentsLabel = showDocumentFolderCounts
    ? formatFolderContentsLabel(
        getDocumentFolderCounts(item).folders_count,
        getDocumentFolderCounts(item).files_count
      )
    : "";

  // Handle dropdown state change
  const handleMenuStateChange = (open) => {
    setIsDropdownOpen(open);
  };

  const getImage = () => {
    switch (type) {
      case "folder":
        return Folder;
      case "file":
        return getIcon();
      default:
        return "";
    }
  };

  const getIcon = () => {
    if (!ext) return FileIcon;
    const extLower = ext.toLowerCase().trim();
    const iconMap = {
      pdf: PDFI,
      gif: GIFI,
      jpg: JPGI,
      jpeg: JPGI,
      png: PNGI,
      csv: CSVI,
      docx: DOCXI,
      xlsx: XLSXI,
      xls: XLSXI,
      doc: DOCI,
      txt: TXTI,
    };
    return iconMap[extLower] || FileIcon;
  };

  // Get color classes based on file extension for colored icon backgrounds
  const getFileTypeColors = () => {
    if (type === "folder") {
      return 'bg-gradient-to-br from-blue-50 to-indigo-50 group-hover:from-blue-100 group-hover:to-indigo-100';
    }
    
    if (!ext) {
      return 'bg-gradient-to-br from-gray-50 to-slate-50 group-hover:from-gray-100 group-hover:to-slate-100';
    }
    
    const extLower = ext.toLowerCase().trim();
    
    // PDF - Maroon/Red
    if (extLower === 'pdf') {
      return 'bg-gradient-to-br from-red-50 to-red-100 group-hover:from-red-100 group-hover:to-red-200';
    }
    
    // Excel - Green
    if (extLower === 'xlsx' || extLower === 'xls') {
      return 'bg-gradient-to-br from-green-50 to-green-100 group-hover:from-green-100 group-hover:to-green-200';
    }
    
    // Word - Blue
    if (extLower === 'docx' || extLower === 'doc') {
      return 'bg-gradient-to-br from-blue-50 to-blue-100 group-hover:from-blue-100 group-hover:to-blue-200';
    }
    
    // Images - Purple/Pink
    if (['png', 'jpg', 'jpeg', 'gif'].includes(extLower)) {
      return 'bg-gradient-to-br from-purple-50 to-pink-50 group-hover:from-purple-100 group-hover:to-pink-100';
    }
    
    // CSV - Teal/Cyan
    if (extLower === 'csv') {
      return 'bg-gradient-to-br from-teal-50 to-cyan-50 group-hover:from-teal-100 group-hover:to-cyan-100';
    }
    
    // Text - Gray
    if (extLower === 'txt') {
      return 'bg-gradient-to-br from-gray-50 to-slate-50 group-hover:from-gray-100 group-hover:to-slate-100';
    }
    
    // Default - Gray
    return 'bg-gradient-to-br from-gray-50 to-slate-50 group-hover:from-gray-100 group-hover:to-slate-100';
  };

  // Get icon filter/style to make icons darker and more visible (only for files, not folders)
  const getIconStyle = () => {
    // Keep folders with original styling - return empty object so no filters applied
    if (type === "folder") {
      return {};
    }
    
    // Apply darker styling only to files
    if (!ext) {
      return { filter: 'brightness(0) saturate(100%)', opacity: 0.6 };
    }
    
    const extLower = ext.toLowerCase().trim();
    
    // PDF - Dark red/maroon icon
    if (extLower === 'pdf') {
      return { filter: 'brightness(0) saturate(100%) invert(15%) sepia(95%) saturate(5000%) hue-rotate(350deg)', opacity: 0.9 };
    }
    
    // Excel - Dark green icon
    if (extLower === 'xlsx' || extLower === 'xls') {
      return { filter: 'brightness(0) saturate(100%) invert(35%) sepia(90%) saturate(1500%) hue-rotate(100deg)', opacity: 0.9 };
    }
    
    // Word - Dark blue icon
    if (extLower === 'docx' || extLower === 'doc') {
      return { filter: 'brightness(0) saturate(100%) invert(25%) sepia(90%) saturate(2000%) hue-rotate(200deg)', opacity: 0.9 };
    }
    
    // Images - Darker icon for contrast
    if (['png', 'jpg', 'jpeg', 'gif'].includes(extLower)) {
      return { filter: 'brightness(0) saturate(100%)', opacity: 0.8 };
    }
    
    // CSV - Dark teal icon
    if (extLower === 'csv') {
      return { filter: 'brightness(0) saturate(100%) invert(45%) sepia(80%) saturate(800%) hue-rotate(150deg)', opacity: 0.9 };
    }
    
    // Text - Dark gray icon
    if (extLower === 'txt') {
      return { filter: 'brightness(0) saturate(100%)', opacity: 0.7 };
    }
    
    // Default - Dark gray icon
    return { filter: 'brightness(0) saturate(100%)', opacity: 0.6 };
  };


  const getBadge = () => {
    if (type !== "file") {
      return null;
    }

    if (item?.expiry_time && moment(item?.expiry_time).isAfter(moment())) {
      // If expiry date is in the future, no badge is shown
      return null;
    }

    switch (badged) {
      case "Replaced":
        return (
          <span className='inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800'>
            Replaced
          </span>
        );
      case "Expiry":
        return (
          <span className='inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-semibold text-red-800'>
            Expired
          </span>
        );
      default:
        return null;
    }
  };

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [currentFileName, setCurrentFileName] = useState("");

  const handleViewDocument = async (url, e) => {
    try {
      if (!url || typeof url !== "string") {
        console.error("Invalid document URL provided");
        toast.error("Invalid document URL. Please try again.");
        return;
      }

      if (e && typeof e.preventDefault === "function") {
        e.preventDefault();
      }

      await openDocumentPreviewInNewTab(url, { isFullUrl: true });
    } catch (error) {
      console.error("Error in handleViewDocument:", error);
      toast.error("An error occurred while opening the document. Please try again.");
    }
  };

  const handleClickHandler = async (e) => {
    if (e === "Change Permission") {
      setIsLoadingViewFile(item.uuid);
      try {
        const response = await apiCall.post({
          url: `${BASE_URL}sp/file-management/file-access`,
          skipQueryParams: false,
          isAuthToken: currentLoginUser?.AccessToken,
          params: {
            id: item?.id, // file id
            visibility: item?.visibility === true ? false : true, // this should be true or false
          },
        });
        
        if (response && response.file) {
          setUpdatePermission(response.file);
          // Update local state in parent component
          if (onFilePermissionUpdate) {
            onFilePermissionUpdate(response.file);
          }
          toast.success("File permissions updated successfully!");
        } else {
          throw new Error("Invalid response from server");
        }
      } catch (error) {
        console.error("Error updating file permissions:", error);
        const errorMessage = error?.response?.data?.message || 
                             error?.message || 
                             "Failed to update file permissions. Please try again.";
        toast.error(errorMessage);
      } finally {
        setIsLoadingViewFile(null);
      }
    } else if (e === "Rename") {
      // Reset dropdown state to close it and restore z-index
      setIsDropdownOpen(false);
      isEdit(true);
      currentFolder(item);
    } else if (e === "Move to folder") {
      setIsDropdownOpen(false);
      if (typeof onMoveToFolder === "function") {
        onMoveToFolder(item, type);
      }
    } else if (e === "Remove") {
      if (isUserGracePeriodOver) return;
      // Reset dropdown state to close it and restore z-index
      setIsDropdownOpen(false);
      setItemToDelete({ type, item });
      setShowDeleteConfirm(true);
    } else if (e === "Edit") {
      // Reset dropdown state to close it and restore z-index
      setIsDropdownOpen(false);
      if (isEditt) {
        isEditt(true);
      }
      if (currentFile) {
        currentFile(item);
      }
    } else if (e === "Download") {
      try {
        await viewfile(e, true);
      } catch (error) {
        // Error handling is already done in viewfile, but we catch here to prevent unhandled promise rejection
        console.error("Error in Download action:", error);
      }
    } else if (e === "Open") {
      setIsDropdownOpen(false);
      if (type === "folder" && onClick) {
        onClick();
      }
    } else if (e === "View") {
      // Use FilePreviewModal instead of opening new tab
      if (onFileClick) {
        try {
          onFileClick(item);
        } catch (error) {
          console.error("Error in onFileClick callback:", error);
          toast.error("An error occurred while opening the file preview. Please try again.");
        }
      } else {
        // Fallback to old method if onFileClick not available
        // Pass null instead of string "View" since no event object is available
        try {
          await viewfile(null);
        } catch (error) {
          // Error handling is already done in viewfile, but we catch here to prevent unhandled promise rejection
          // and ensure loading state is cleared
          console.error("Error in View action:", error);
          // Loading state is already cleared in viewfile's catch block
        }
      }
    }
  };

  const canConfirmDeleteFolder = () => {
    if (role === "hrm" && isFrontlineEmployeeUser()) {
      return (
        canAccessFrontlineMyDocumentsFolderAction(
          DOCUMENT_PERMISSION_ACTIONS.FOLDER_DELETE
        ) ||
        canAccessDocumentAction(role, DOCUMENT_PERMISSION_ACTIONS.FOLDER_DELETE)
      );
    }
    return canAccessDocumentAction(
      role,
      DOCUMENT_PERMISSION_ACTIONS.FOLDER_DELETE
    );
  };

  const canConfirmDeleteFile = () =>
    canAccessDocumentAction(role, DOCUMENT_PERMISSION_ACTIONS.DELETE);

  const handleConfirmDelete = () => {
    if (!itemToDelete) return;

    const { type, item } = itemToDelete;
    const allowed =
      type === "folder" ? canConfirmDeleteFolder() : canConfirmDeleteFile();
    if (!allowed) {
      toast.error(
        type === "folder"
          ? role === "participant"
            ? PARTICIPANT_DOCUMENT_FOLDER_DELETE_DENIED
            : "You do not have permission to delete this folder."
          : "You do not have permission to delete documents."
      );
      setShowDeleteConfirm(false);
      setItemToDelete(null);
      return;
    }
    setShowDeleteConfirm(false);
    
    if (type === "folder") {
      // Use id if available, otherwise fallback to uuid
      // This matches the pattern used throughout the codebase: item.uuid || folder-${item.id}
      const folderId = item.id || item.uuid;
      if (!folderId) {
        toast.error(`Cannot delete folder "${item.name || 'Unknown'}": missing identifier`);
        setItemToDelete(null);
        return;
      }
      
      setIsLoadingViewFile(item.uuid);
      removeFolder(
        {
          folder_id: folderId,
          ...(role === "participant"
            ? { role: "participant", skipToast: true }
            : {}),
        },
        (res, error) => {
        setIsLoadingViewFile(null);
        if (!error) {
          if (role === "participant") {
            toast.success("Folder Deleted Successfully!");
          }
          return;
        }
        if (role === "participant") {
          toast.error(
            isParticipantFolderDeleteDeniedError(error)
              ? PARTICIPANT_DOCUMENT_FOLDER_DELETE_DENIED
              : error?.message || "Failed to delete folder. Please try again."
          );
          return;
        }
        toast.error("Failed to delete folder. Please try again.");
      });
    } else {
      // Files should also handle uuid fallback for consistency
      const fileId = item.id || item.uuid;
      if (!fileId) {
        toast.error(`Cannot delete file "${item.description || item.name || 'Unknown'}": missing identifier`);
        setItemToDelete(null);
        return;
      }
      
      setIsLoadingViewFile(item.uuid);
      removeFile({ file_management_id: fileId }, (res, error) => {
        setIsLoadingViewFile(null);
        if (error) {
          toast.error("Failed to delete file. Please try again.");
        }
        // Success message is handled by the saga, no need to show duplicate toast
      });
    }
    localStorage.setItem("removedItem", JSON.stringify(item));
    setItemToDelete(null);
  };

  const viewfile = async (e, isForDownload = false) => {
    setIsLoadingViewFile(item.uuid);
    try {
      const viewFileBaseUrl = (() => {
        if (role === "sil") {
          return URL_SIL_ACCOMMODATION_DOCUMENT_VIEW_FILE;
        }
        if (roleAccess([USER_ROLE.Sp_Standard_User])) {
          return URL_WORKER_GET_FILE;
        }
        if (fileViewContext === "worker") {
          if (roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager])) {
            return URL_GET_FILE;
          }
          return URL_WORKER_GET_FILE;
        }
        return URL_GET_FILE;
      })();

      const response = await apiCall.get({
        url: `${viewFileBaseUrl}?file_management_uuid=${item.uuid}`,
        isAuthToken: currentLoginUser?.AccessToken,
        params: {},
      });

      if (isForDownload) {
        const downloadUrl = sanitizeDocumentUrl(baseURLImage(response?.link));
        if (downloadUrl) {
          try {
            window.open(downloadUrl, "_blank");
          } catch (windowError) {
            console.error("Error opening download URL:", windowError);
            toast.error("Unable to open download. Please check your popup blocker settings.");
          }
        } else {
          console.error("Download URL not found in response");
          toast.error("Download URL not available. Please try again.");
        }
      } else {
        const documentUrl = sanitizeDocumentUrl(baseURLImage(response?.link));
        if (documentUrl) {
          handleViewDocument(documentUrl, e, response);
        } else {
          console.error("Document URL not found in response");
          toast.error("Document URL not available. Please try again.");
        }
      }
    } catch (error) {
      console.error("Error fetching document URL:", error);
      const errorMessage = error?.response?.data?.message || 
                           error?.message || 
                           "Failed to load document. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsLoadingViewFile(null);
    }
  };

  const handleCardClick = (e) => {
    // Don't trigger if clicking on interactive elements (dropdown, buttons, checkboxes)
    if (
      e.target.closest('button') ||
      e.target.closest('[role="menu"]') ||
      e.target.closest('.absolute') ||
      e.target.closest('[class*="dropdown"]') ||
      e.target.closest('[class*="Menu"]') ||
      e.target.closest('[data-doc-move-drag]')
    ) {
      return;
    }
    
    // Handle single click for folders
    if (type === "folder" && onClick) {
      onClick();
    }
    // Handle single click for files to open preview
    else if (type === "file") {
      if (typeof onFileClick === "function") {
        try {
          onFileClick(item);
        } catch (error) {
          console.error("Error in onFileClick:", error);
          toast.error("An error occurred while opening the file. Please try again.");
        }
      } else {
        void viewfile(null);
      }
    }
  };

  return (
    <div
      className={`
        group relative h-full overflow-hidden cursor-pointer
        bg-white border border-gray-200 rounded-xl
        shadow-sm hover:shadow-lg hover:shadow-blue-100/50
        transition-all duration-300 ease-out
        hover:-translate-y-1 hover:border-blue-300
        ${isMoveDropOver ? "ring-2 ring-blue-400 ring-offset-1" : ""}
      `}
      onClick={handleCardClick}
      onDragEnter={showMoveDropTarget ? handleFolderDragEnter : undefined}
      onDragLeave={showMoveDropTarget ? handleFolderDragLeave : undefined}
      onDragOver={showMoveDropTarget ? handleFolderDragOver : undefined}
      onDrop={showMoveDropTarget ? handleFolderDrop : undefined}
      style={{
        zIndex: isDropdownOpen ? 2 : undefined,
      }}
    >
      {viewMode === "grid" ? (
        // Grid View - actions on top row; icon below with checkbox clearance (no overlap)
        <div
          className={`px-3 py-3 flex flex-col min-h-0 ${
            type === "folder" ? "h-auto min-h-[7.25rem] pb-1" : "h-full"
          }`}
        >
          <div className='flex justify-end items-center min-h-[1.75rem] mb-2 pr-0.5'>
            {renderActionToolbar()}
          </div>

          <div className={`flex items-start ${docCardContentPad} pr-1 mb-2 min-h-[2.75rem]`}>
            <div
              className={`
              relative p-2 rounded-lg transition-all duration-300 flex-shrink-0
              ${getFileTypeColors()}
            `}
            >
              <img
                src={getImage()}
                alt={type === "folder" ? "folder" : "file"}
                draggable={false}
                className={`${isFrontlinePortalDocs ? "h-10 w-10" : "h-9 w-9"} object-contain flex-shrink-0 transition-transform duration-300 group-hover:scale-105`}
                style={{ display: "block", ...getIconStyle() }}
              />
            </div>
          </div>

          {/* Name below icon row */}
          <div
            className={`flex flex-col justify-start items-start px-0 mb-1 ${docCardContentPad} pr-2 min-w-0 max-w-full gap-1`}
          >
            <div
              className='font-semibold text-sm text-gray-900 group-hover:text-blue-700 transition-colors text-left max-w-[calc(100%-2rem)] sm:max-w-[calc(100%-2.5rem)] leading-5'
              title={
                label ||
                item?.name ||
                item?.description ||
                (type === "file" ? "Untitled File" : "Untitled Folder")
              }
              style={
                type === "file"
                  ? {
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      wordBreak: "break-word",
                      lineHeight: "1.3",
                      minHeight: "2.6em",
                    }
                  : {
                      wordBreak: "break-word",
                      overflow: "visible",
                    }
              }
            >
              {label ||
                item?.name ||
                item?.description ||
                (type === "file" ? "Untitled File" : "Untitled Folder") ||
                "No Name"}
            </div>
            {showDocumentFolderCounts && folderContentsLabel ? (
              <p className='text-[11px] font-normal leading-snug text-gray-500 normal-case w-full'>
                {folderContentsLabel}
              </p>
            ) : null}
          </div>

          {/* Badge and file metadata */}
          <div className={`mt-1.5 pr-2 ${docCardContentPad} max-w-full overflow-hidden`}>
            {type === "file" && (
              <div className='flex flex-wrap items-center gap-1.5 text-gray-500 font-normal text-xs'>
                {item?.expiry_time &&
                  moment(item?.expiry_time).isValid() &&
                  moment(item?.expiry_time).year() >= 1900 &&
                  moment(item?.expiry_time).year() <= 9999 &&
                  moment(item?.expiry_time).isBefore(moment(), "day") && (
                  <span className='text-red-600 text-[10px] font-medium bg-red-50 px-2 py-0.5 rounded-full break-words'>
                    Expired {moment(item?.expiry_time).format("DD MMM YYYY")}
                  </span>
                )}
                {item?.expiry_time &&
                  moment(item?.expiry_time).isValid() &&
                  moment(item?.expiry_time).year() >= 1900 &&
                  moment(item?.expiry_time).year() <= 9999 &&
                  moment(item?.expiry_time).isSameOrAfter(moment(), "day") && (
                  <span className='text-[10px] bg-amber-50 text-amber-700 px-2 py-0.5 rounded-full break-words'>
                    Expires {moment(item?.expiry_time).format("DD MMM YYYY")}
                  </span>
                )}
                {item?.size && (
                  <span className='text-[10px] text-gray-600 whitespace-nowrap'>
                    {item.size < 1024
                      ? item.size + " B"
                      : item.size < 1024 * 1024
                      ? (item.size / 1024).toFixed(2) + " KB"
                      : (item.size / (1024 * 1024)).toFixed(2) + " MB"}
                  </span>
                )}
                {type === "file" && role === "participant" && (
                  <div>
                    {item?.visibility === false ? (
                      <div className='flex items-center gap-1 text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full'>
                        <MdOutlinePublic className='text-xs' />
                        <span className='text-[10px] font-medium'>Public</span>
                      </div>
                    ) : (
                      <div className='flex items-center gap-1 text-gray-600 bg-gray-50 px-2 py-0.5 rounded-full'>
                        <RiGitRepositoryPrivateLine className='text-xs' />
                        <span className='text-[10px] font-medium'>Private</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        // List View - Horizontal Layout
        <div className='px-4 py-4 overflow-hidden' style={{ position: 'relative' }}>
          <div className='flex justify-between items-center gap-4 min-w-0'>
            <div className='flex items-center gap-3 flex-1 min-w-0 pr-2'>
              <div className={`p-2 rounded-lg transition-all duration-300 flex-shrink-0 ${getFileTypeColors()}`}>
                <img
                  src={getImage()}
                  alt={type === "folder" ? "folder" : "file"}
                  draggable={false}
                  className='h-8 w-8 object-contain flex-shrink-0'
                  style={{ display: 'block', ...getIconStyle() }}
                />
              </div>
              <div className='min-w-0 flex-1 overflow-hidden'>
                <div 
                  className='font-semibold text-normal text-gray-800 truncate' 
                  title={label || (type === "file" ? "Untitled File" : "Untitled Folder")}
                >
                  {label || (type === "file" ? "Untitled File" : "Untitled Folder")}
                </div>
              </div>
            </div>
            <div className='flex-shrink-0 pl-2'>
              {renderActionToolbar()}
            </div>
          </div>
          <div>
            {badged !== "" && item?.is_expire === true && getBadge()}
            {showDocumentFolderCounts && folderContentsLabel ? (
              <p className='mt-1 text-[11px] font-normal leading-snug text-gray-500 normal-case'>
                {folderContentsLabel}
              </p>
            ) : null}
            {type === "file" && (
              <div className='flex items-center justify-between text-gray-400 font-normal text-sm'>
                <div className='flex flex-col gap-1 mt-1'>
                  {item?.expiry_time &&
                  moment(item?.expiry_time).isValid() &&
                  moment(item?.expiry_time).year() >= 1900 &&
                  moment(item?.expiry_time).year() <= 9999 &&
                  moment(item?.expiry_time).isBefore(moment(), "day")
                    ? <span className="text-[10px] bg-red-50 text-red-700 whitespace-normal">Expired on {moment(item?.expiry_time).format("DD MMM YYYY")}</span>
                    : item?.expiry_time &&
                      moment(item?.expiry_time).isValid() &&
                      moment(item?.expiry_time).year() >= 1900 &&
                      moment(item?.expiry_time).year() <= 9999 &&
                      moment(item?.expiry_time).isSameOrAfter(moment(), "day") &&
                      <span className="text-[10px] bg-amber-50 text-amber-700 whitespace-normal"> Expires on {moment(item?.expiry_time).format("DD MMM YYYY")}</span>
                    }
                  {item?.size && (
                    <span className='text-xs'>
                      {item.size < 1024
                        ? item.size + " B"
                        : item.size < 1024 * 1024
                        ? (item.size / 1024).toFixed(2) + " KB"
                        : (item.size / (1024 * 1024)).toFixed(2) + " MB"}
                    </span>
                  )}
                </div>
                {role === "participant" && type === "file" && (
                  <div
                    className={`${
                      item?.visibility === true
                        ? "hover:text-red-700 text-[#DDDDD]"
                        : "hover:text-green-700 text-[#DDDDD]"
                    }`}
                  >
                    {item?.visibility === false ? (
                      <MdOutlinePublic
                        title='Public'
                        className='text-xl font font-semibold'
                      />
                    ) : (
                      <RiGitRepositoryPrivateLine
                        title='Private'
                        className='text-xl font font-semibold'
                      />
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      
      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        showModal={showDeleteConfirm}
        closeModalHandler={() => {
          setShowDeleteConfirm(false);
          setItemToDelete(null);
        }}
        submitHandler={handleConfirmDelete}
        title="Confirm Delete"
        heading={
          itemToDelete
            ? `Are you sure you want to delete "${itemToDelete.item.name || itemToDelete.item.description}"?`
            : "Are you sure you want to delete this item?"
        }
        isNew={true}
        cancelBtnLabel="Cancel"
        confirmBtnLabel="Delete"
        variantConfirmBtn="danger"
      />

        {/* File/Folder Metadata - Now shown in sidebar */}
    </div>
  );
};

const mapStateToProps = (state) => {
  const currentLoginUser = getUser(state);
  return { currentLoginUser };
};
export default connect(mapStateToProps, null)(FolderView);
